import { DayWithoutTotal } from '../../../+authenticated/+schedule/shared/schedule.interfaces';
import { AbsenceModel } from '../../../reducers/orm/absence/absence.model';
import { AvailabilityModel } from '../../../reducers/orm/availability/availability.model';
import { ScheduleModel } from '../../../reducers/orm/schedule/schedule.model';
import { PayloadKeyType } from '../../../reducers/shared/entity.helper';
import { calculateScheduleRowHeight, update } from '../../../reducers/store/schedule-shared.helper';

interface EmployeeSourceData {
  schedules: ScheduleModel[];
  absences: AbsenceModel[];
  availabilities: AvailabilityModel[];
}

export const groupEmployeeData = (data: EmployeeSourceData, totals: DayWithoutTotal[]) => {
  const { schedules, absences, availabilities } = data;

  let users = {};
  const mappedAvailabilities = availabilities.filter((availability) => availability.type);

  users = update(users, schedules, PayloadKeyType.SCHEDULES, 'occurrence_id');
  users = update(users, absences, PayloadKeyType.ABSENCE);
  users = update(users, mappedAvailabilities, PayloadKeyType.AVAILABILITIES, 'date');

  return Object.values(users).map((user: any) => {
    const userSchedules = Object.values(user.schedules);
    return {
      ...user,
      filteredSchedules: user.schedules,
      scheduleTeams: [...new Set(userSchedules.map((schedule: any) => schedule.team_id))],
      rowHeight: calculateScheduleRowHeight(user, totals),
    };
  });
};
